export function Debounce(delay: number) {
    return (target: any, propertyKey: string, descriptor: PropertyDescriptor) => {
        const originalMethod = descriptor.value;
        let timeoutId = 0;

        const clear = () => {
            if (timeoutId) {
                clearTimeout(timeoutId);
                timeoutId = 0;
            }
        };

        // eslint-disable-next-line
        descriptor.value = function(...args: any[]) {
            clear();
            timeoutId = window.setTimeout(() => {
                timeoutId = 0;
                originalMethod.apply(this, args);
            }, delay);
        };

        return descriptor;
    };
}
